<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
            v-model="searchForm.title"
            placeholder="广告标题"
            width="50"
          />
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.state"
                  placeholder="状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.velue"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >
      新增
    </el-button>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="标题"
      >
        <template slot-scope="scope">
          {{scope.row.title}}
        </template>
      </el-table-column>
      <el-table-column
        label="图片"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.media_type=='2'">
            <video
                   v-bind:src="getImgUrl(scope.row)"
                   class="avatar video-avatar"
                   controls="controls"  style="width: 200px;height: 100px; "></video>
          </div>
          <div v-else>
            <img :src= "getImgUrl(scope.row)" style="width: 80px;height: 80px; "/>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="投放对象"
        prop="sort_id"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.target_delivery=='1'">
            商户
          </div>
          <div v-else-if="scope.row.target_delivery=='2'">
            客户
          </div>
          <div v-else-if="scope.row.target_delivery=='3'">
            付款设备
          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="投放范围"
              prop="sort_id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.delivery_scope=='1'">
            一级代理所属商户
          </div>
          <div v-else-if="scope.row.delivery_scope=='2'">
            二级代理所属商户
          </div>
          <div v-else-if="scope.row.delivery_scope=='3'">
            三级代理所属商户
          </div>
          <div v-else-if="scope.row.delivery_scope=='4'">
            服务商所属商户
          </div>
          <div v-else-if="scope.row.delivery_scope=='5'">
            城市
          </div>
          <div v-else-if="scope.row.delivery_scope=='6'">
            商户收款后页面
          </div>
          <div v-else-if="scope.row.delivery_scope=='7'">
            客户小程序
          </div>
          <div v-else-if="scope.row.delivery_scope=='8'">
            客户付完款页面
          </div>
          <div v-else-if="scope.row.delivery_scope=='9'">
            启动页
          </div>
          <div v-else-if="scope.row.delivery_scope=='10'">
            收银页
          </div>
          <div v-else-if="scope.row.delivery_scope=='11'">
            支付成功页
        </div>
          <div v-else-if="scope.row.delivery_scope=='12'">
            收押金成功页
          </div>
          <div v-else-if="scope.row.delivery_scope=='13'">
            退押金成功页
          </div>

        </template>
      </el-table-column>
      <el-table-column
              label="行业分类"
              prop="industry_classification"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.industry_classification}}
        </template>
      </el-table-column>
      <el-table-column
              label="曝光"
              prop="sort_id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">


          <span style="color:red;" @click="openExposureForm(scope.row)">  {{scope.row.exposure}}</span>
        </template>
      </el-table-column>
      <el-table-column
              label="点击"
              prop="sort_id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span style="color:red;" @click="openClicksForm(scope.row)">  {{scope.row.clicks}}</span>
        </template>
      </el-table-column>
      <el-table-column
              label="状态"
              prop="sort_id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state=='0'">
            正常
          </div>
          <div v-else-if="scope.row.state=='1'">
           禁用
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="时间"
              prop="sort_id"
              width="150"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.start_time}}--{{scope.row.end_time}}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="220"
      >
        <template slot-scope="scope">
          <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="openEditForm(scope.row)"
          >编辑</el-button>
            <el-button
                    v-if="scope.row.state=='0'"
                    type="primary"
                    plain
                    size="mini"
                    @click="update(scope.row.id,1)"
            >禁用</el-button>
            <el-button
                    v-if="scope.row.state=='1'"
                    type="primary"
                    plain
                    size="mini"
                    @click="update(scope.row.id,0)"
            >恢复</el-button>

          <el-button
            type="primary"
            plain
            size="mini"
            @click="del(scope.row.id)"
          >删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneclass="oneclass"
      v-model="editFormVisible"
      @submit="getTableData"
    />

    <exposure-form
            :agent="oneclass"
            v-model="exposureFormVisible"
            @submit="getTableData"
    />

    <clicks-form
            :agent="oneclass"
            v-model="clicksFormVisible"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as oneclassService from "@/api/sys/oneclass";
import * as agentService from "@/api/sys/agent";
import editForm from "./editForm";
import util from '@/libs/util.js'
import exposureForm from "./exposureForm";
import clicksForm from "./clicksForm";
export default {
  name: "PosterPage",
  components: { editForm,exposureForm,clicksForm },
  data() {
    return {
      searchForm: {
          advTitle: ""
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
        typeOptions: [
            {
                value: "0",
                label: "正常"
            },
            {
                value: "1",
                label: "禁用"
            }
        ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
        clicksFormVisible:false,
        exposureFormVisible: false,
      editFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
          dl_type: util.cookies.get('dl_type'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getAdvertPagedList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
      getImgUrl(row){
          return "https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/"+row.picture;
      },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(oneclass) {
      this.oneclass = oneclass;
      this.editFormVisible = true;
    },
      openExposureForm(oneclass) {
          this.oneclass = oneclass;
          this.exposureFormVisible = true;
      },
      openClicksForm(oneclass) {
          this.oneclass = oneclass;
          this.clicksFormVisible = true;
      },

    add() {
      this.oneclass = {};
      this.editFormVisible = true;
    },
    batchDel() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          agentService
          .batchAdvert({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData();
          });
      });
    },
      update(id,type){
          let msg = type == 1 ? "禁用" : "恢复";
          this.$confirm("确认"+msg+"操作？", "确认信息", {
              distinguishCancelAndClose: true,
              confirmButtonText: msg,
              cancelButtonText: "取消"
          }).then(() => {
              agentService.updateAdvert({id:id,state:type}).then(() => {
                  this.getTableData();
              });
          });
      },
    del(id) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          agentService.delAdvert({id:id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
